import { render, staticRenderFns } from "./FreeConnectionsHeader.vue?vue&type=template&id=7065059a&scoped=true"
import script from "./FreeConnectionsHeader.vue?vue&type=script&lang=js"
export * from "./FreeConnectionsHeader.vue?vue&type=script&lang=js"
import style0 from "./FreeConnectionsHeader.vue?vue&type=style&index=0&id=7065059a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7065059a",
  null
  
)

export default component.exports